<template>
	<div>

		<form enctype="multipart/form-data" v-if="!input_xmls.length">
			<div
				class="input-group"
				@dragenter="dragclass='dragclass'"
				@dragleave="dragclass=''"
				@dragend="dragclass=''">
				<div class="custom-file">
					<input
						type="file"
						id="drop_zone"
						class="custom-file-input"
						ref="file"
						@change="get_files"
						multiple>
					<label
						:class="dragclass"
						class="custom-file-label elevation-4"
						for="file_input">
						<h5 class="headline">Déposez vos xml ici ou Cliquez pour browser</h5>
					</label>
				</div>
			</div>
		</form>

		<v-form ref="unitary_form">
			<v-text-field
				style="visibility: hidden; height: 0; padding: 0; margin: 0"
				name="XMLS Lagardère"
				v-if="form"
				v-model="form.parameters.order_data"
				:rules="[lagCheck]">
			</v-text-field>
		</v-form>

		<v-layout row wrap v-if="input_xmls.length">
			<v-spacer></v-spacer>
			<v-btn flat color="warning" @click="remove_all()" class="text-none mr-3">
				<v-icon left>close</v-icon>
				Tout supprimer
			</v-btn>
		</v-layout>

		<v-progress-linear v-if="loading" :indeterminate="true" />

		<v-expansion-panel v-if="input_xmls.length">
			<v-expansion-panel-content v-for="(xml,i) in input_xmls" :key="'xml' + i" class="background darken-2">
				<template v-slot:header>
					<div>{{ xml.file }}</div>
				</template>
				<v-card color="background darken-2">
					<v-card-text class="pa-2">
						<tree-view :data="xml.content" :options="{maxDepth: 3, rootObjectKey: xml.file}" />
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn outline color="warning" @click="remove_one(i)" class="text-none">
							<v-icon left>close</v-icon>
							Supprimer
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>

		<v-alert type="error" :value="true" v-for="(err,i) in errors" :key="'err' + i">
			{{ err }}
		</v-alert>

		<v-card class="pa-2 mb-3" v-if="debug">
			<tree-view :data="input_xmls" :options="{maxDepth: 3, rootObjectKey: 'Output'}" />
		</v-card>

		<v-card class="pa-2" v-if="debug">
			<tree-view :data="wf_data" :options="{maxDepth: 0, rootObjectKey: 'Job Descriptor'}" />
		</v-card>

	</div>
</template>

<script>

import xmljs from 'xml-js'
export default {
	name: '',
	props: ['debug', 'wf_data', 'details', 'form'],
	data () {
		return {
			dragclass: '',
			loading: false,
			input_xmls: [],
			errors: []
		}
	},
	watch: {
		input_xmls (xmls) {
			let forms = []
			for (var i = 0; i < xmls.length; i++) {
				forms.push({
					isValid: true,
					parameters: {
						'order_id': xmls[i].id,
						'order_data': xmls[i].content,
						'type': this.getPackageType(xmls[i].content)
					}
				})
			}
			this.$emit('change', forms)
		}
	},
	methods: {
		remove_one (index) {
			this.input_xmls.splice(index, 1)
		},
		remove_all () {
			this.input_xmls = []
		},
		getPackageType (orderData) {
			let packageType = []
			let hasSme = false
			let hasVm = false
			if (orderData.commande.hasOwnProperty('video')) packageType.push('mxf')
			this.$commons.deepGet(orderData, 'commande.subtitles.subtitle', []).map(sub => {
				if (sub.mode._attributes.id === 'CC') {
					if (sub.code._attributes.id === 'SME') hasSme = true
					if (sub.code._attributes.id === 'VM') hasVm = true
				}
			})
			if (hasVm) packageType.push('vm')
			if (hasSme) packageType.push('sme')
			return packageType.join('+')
		},
		get_files () {
			this.errors = []
			this.input_xmls = []
			this.dragclass = ''
			this.loading = true
			let InputFiles = this.$refs.file.files

			if (InputFiles.length === 0) {
				this.loading = false
				return
			}

			for (let i = 0; i < InputFiles.length; i++) {
				let fileName = InputFiles[i].name
				let fileExt = fileName.substring(fileName.lastIndexOf('.'), fileName.length)
				if (fileExt.toLowerCase() !== '.xml') {
					this.loading = false
					return
				}
			}

			let that = this
			async function batch (filesList) {
				for (let file of filesList) {
					try {
						let result = await that.fileAnalyzer(file)
						that.input_xmls.push(result)
					} catch (error) {
						throw error
					}
				}
			}

			batch(InputFiles)
				.then(result => {
					this.loading = false
				})
				.catch(error => {
					this.input_xmls = []
					this.errors.push(error.stack)
					this.loading = false
				})
		},
		fileAnalyzer (file) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader()
				reader.onloadend = e => {
					try {
						let eztJson = xmljs.xml2js(reader.result, {compact: true, spaces: 4})
						if (eztJson.commande.audios.hasOwnProperty('audio')) {
							if (eztJson.commande.audios.audio.length === undefined) {
								eztJson.commande.audios.audio = [eztJson.commande.audios.audio]
							}
						}
						if (eztJson.commande.subtitles.hasOwnProperty('subtitle')) {
							if (eztJson.commande.subtitles.subtitle.length === undefined) {
								eztJson.commande.subtitles.subtitle = [eztJson.commande.subtitles.subtitle]
							}
						}
						let output = {
							file: file.name,
							id: eztJson.commande._attributes.id,
							content: eztJson
						}
						resolve(output)
					} catch (error) {
						reject(new Error(`Getting data from ${file.name}: ${error.message}`))
					}
				}
				reader.readAsText(file)
			})
		},
		lagCheck () {
			if (this.input_xmls.length === 0) return 'Au moins un XML requis'
			return true
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		}
	},
	mounted () {
		if (!this.details) return
		if (Object.keys(this.details).length === 0) return
		let content = this.details['order_data'] || null
		let id = this.details['order_id'] || null
		if (content && id) {
			this.input_xmls.push({ file: id + '.xml', id: id, content: content })
		}
	}
}
</script>

<style scoped lang="stylus">

.dragclass
	background-color: var(--v-primary-base) !important
	border: 1px solid var(--v-primary-base) !important
	color: var(--v-background-base) !important

.custom-file-label
.custom-file-input
.custom-file
	height: 140px
	cursor: pointer

.custom-file-label
	text-align: center
	color: var(--v-primary-base)
	background-color: rgba(0, 0, 0, 0.15)
	border: 2px dashed var(--v-primary-base)
	padding-top: 3.5rem
	height: 140px
	&:after
		visibility: hidden
>>>.v-expansion-panel__header
	padding: 0 1em
	border-top: 2px solid var(--v-background-darken1)
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_lagardere.vue